import type { ReactNode } from "react";

import { Badge } from "@/components/ui/Badge";
import { HoverHintDefinitionGrid } from "@/components/ui/HoverHintDefinitionGrid";
import { HoverHintTrigger } from "@/components/ui/title-help";
import { EM_DASH } from "@/lib/utils";

function formatUsd(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) {
    return EM_DASH;
  }
  return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function QboMvMismatchBadge({
  megaventoryTotal,
  quickbooksTotal,
  reason,
}: {
  megaventoryTotal?: number | null;
  quickbooksTotal?: number | null;
  reason?: string | null;
}): ReactNode {
  const delta =
    megaventoryTotal != null &&
    quickbooksTotal != null &&
    Number.isFinite(megaventoryTotal) &&
    Number.isFinite(quickbooksTotal)
      ? Math.abs(quickbooksTotal - megaventoryTotal)
      : null;
  const why = reason?.trim() ? reason.trim() : "QuickBooks invoice total differs from the Megaventory GOSI line sum.";

  return (
    <HoverHintTrigger
      align="start"
      trigger={
        <span className="inline-flex shrink-0" tabIndex={0}>
          <Badge tone="warning" className="text-[10px]">
            QBO ≠ MV
          </Badge>
        </span>
      }
    >
      <HoverHintDefinitionGrid
        rows={[
          { label: "QuickBooks invoice", value: <span className="tabular-nums">{formatUsd(quickbooksTotal)}</span> },
          { label: "Megaventory GOSI", value: <span className="tabular-nums">{formatUsd(megaventoryTotal)}</span> },
          { label: "Difference", value: <span className="tabular-nums">{formatUsd(delta)}</span> },
          { label: "Why", value: why },
        ]}
      />
    </HoverHintTrigger>
  );
}
